import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';

import { ReferenceDataField } from '~/components/ReferenceData';

const Fields = ({ disabled }) => {
  const { values } = useFormikContext();

  return (
    <fieldset disabled={disabled}>
      <Row form>
        <Col sm={6}>
          <ReferenceDataField
            tableName="allergy"
            name="allergyUid"
            disabled={disabled}
            required
          />
        </Col>

        <Col sm={6}>
          <ReferenceDataField
            tableName="medication"
            name="medicationUid"
            required={values.allergyUid.allergyName === 'Medication'}
            disabled={disabled || values.allergyUid === ''}
          />
        </Col>

        <Col sm>
          <Field
            name="comments"
            type="textarea"
            rows={4}
          />
        </Col>

      </Row>
    </fieldset>
  );
};

Fields.propTypes = {
  disabled: PropTypes.bool,
};

Fields.defaultProps = {
  disabled: false,
};

export default Fields;
